"use client";

import { useEffect } from "react";

import { ownerInit, profileInit, useTheme } from "@up/data";

import { brazeInit } from "./braze-init";
import { datadogInit } from "./datadog-init";
import { heapLoaderInit } from "./heap-loader";

export const FrontendInit = () => {
  const theme = useTheme();

  useEffect(() => {
    brazeInit();
    heapLoaderInit(process.env.NEXT_PUBLIC_HEAP_ID);
    if (theme.analyticsPartnerName) {
      datadogInit();
    }

    profileInit();
    ownerInit();
  }, []);
  return null;
};
